
app.core.main();